export default __webpack_public_path__ + "static/media/logo-spotify.94e384cc.svg";